import type React from 'react';

import { Alert, Heading } from '@zillow/constellation-10';

import type { AlertPropsInterface } from '@zillow/constellation-10';

type Props = {
  title?: string | null;
  body: string | React.ReactNode;
  appearance: AlertPropsInterface['tone'];
};

const AlertWithTitle = ({ title, body, appearance }: Props) => (
  <Alert tone={appearance}>
    {title && (
      <Heading level={3} textStyle="body-lg-bold" css={{ lineHeight: '1.2em' }}>
        {title}
      </Heading>
    )}
    <div>{body}</div>
  </Alert>
);

export default AlertWithTitle;
